import React, { useEffect } from "react";
import { SoundfontSynth } from "../components/audio/instruments/SoundfontSynth";
import { RydCollapsableCard } from "../components/widgets/RydCollapsableCard";
import { Groovebox } from "../components/audio/instruments/Groovebox";
import { wrap } from "./RydTestbedWrap";
import * as ToneJS from "tone";
import { RydSpectrogram } from "../components/inspector/RydSpectrogram";
import TR808Drum, { DrumTime } from "../audio/instruments/TR808Drum";
import { getAudioContext } from "../audio/AudioController";
import {
    OscConfig,
    ThreeVoiceSynth
} from "../audio/instruments/ThreeMonoSynth";
import { ThreeVoiceSynthBundle } from "../components/audio/instruments/3VoiceSynth";
import { TrAcht } from "../components/audio/instruments/TrAcht";


/* This should be created elsewhere, near the sequence controller.
The react component, on initialization, should call deepRefSetter
with callbacks to change the style of the pads responding to attack
and release events are triggered, respectively.
*/
export function VirtualInstrumentsTestbed() {

    const [synth, setSynth] = React.useState<ThreeVoiceSynth<ToneJS.SynthOptions>>();
    const [audioContext, setAudioContext] = React.useState<AudioContext>();
    const [drum, setDrum] = React.useState<TR808Drum>();

    useEffect(() => {
        const ac = getAudioContext();
        setAudioContext(ac);
        console.log('Creating new AudioContext:', ac);
        ToneJS.setContext(ac);
        ToneJS.start();

        const _drum = new TR808Drum();
        _drum.connect(ac.destination);
        setDrum(_drum);

        const oscConfigs: OscConfig[] = [
            { type: "sine", frequency: 440, mix: 0.5, detune: 0 },
            { type: "sawtooth", frequency: 440, mix: 0.5, detune: 0 },
            { type: "triangle", frequency: 440, mix: 0.5, detune: 0 },
        ];

        const filterConfig: ToneJS.FilterOptions = {
            ...ToneJS.Filter.getDefaults(),
            type: "lowpass",
            frequency: 800,
            Q: 1,
        };

        const envConfig: ToneJS.EnvelopeOptions = {
            ...ToneJS.AmplitudeEnvelope.getDefaults(),
            attack: 0.01,
            decay: 0.2,
            sustain: 0.7,
            release: 0.5,
        };

        const delayConfig: ToneJS.DelayOptions = {
            ...ToneJS.FeedbackDelay.getDefaults(),
            delayTime: 0.25
        };

        const chorusConfig: ToneJS.ChorusOptions = {
            ...ToneJS.Chorus.getDefaults(),
            frequency: 1.5,
            delayTime: 3.5,
            depth: 0.7,
            feedback: 0.1,
            type: "sine",
        };

        const reverbConfig = {
            decay: 1.5,
            preDelay: 0.01
        };

        const s = new ThreeVoiceSynth(oscConfigs, filterConfig, envConfig, delayConfig, chorusConfig, reverbConfig, { standaloneOutput: true });
        setSynth(s);

    }, []);

    if (!audioContext) return <div>Loading...</div>;
    if (!drum?.outputNode) return <div>Loading drum...</div>;

    return wrap(
        <div>
            <h1>Virtual Instruments Testbed</h1>
            <RydCollapsableCard title="Drumkit">
                <TrAcht drum={drum} />
                <RydSpectrogram audioContext={audioContext} source={drum.outputNode} />
            </RydCollapsableCard>

            <RydCollapsableCard title="3 voices">
                {synth && <>
                    <ThreeVoiceSynthBundle synth={synth} />
                    <RydSpectrogram audioContext={audioContext} source={synth.getOutputNode()} />

                </>}
            </RydCollapsableCard>

            <RydCollapsableCard title="Soundfont Synth">
                <SoundfontSynth />
            </RydCollapsableCard>

            <RydCollapsableCard title="Groovebox">
                <Groovebox />
            </RydCollapsableCard>
        </div>
    );
}
